import { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import StudentHeader from "./StudentHeader";
import StudentTable from "./StudentTable";
import { fetchData } from "../../utils/options";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const StudentList = () => {
  const navigate=useNavigate()
  const [students, setStudents] = useState([]);

const [allStudents, setAllStudents] = useState([]);


useEffect(()=>{
window.scrollTo(0,0)
if(!localStorage.getItem("access_token"))navigate("/")
},[])
 
  useEffect(() => {
    loadAllStudents();
  }, []);

  const loadAllStudents = async () => {
try{
  Swal.fire({
    title:"loading",
    allowOutsideClick:false,
didOpen:()=>{
  Swal.showLoading()
}
  })


    const result = await fetchData("list/register", {}, "POST");
    if (result) {
      setStudents(result.data);
      setAllStudents(result.data);
    }}
    catch(error){
      console.log(error)
    }
  finally{
    Swal.close()
  }
}

  // When filter sends result
const handleFiltered = (filteredData) => {
  if (!filteredData || filteredData.length === 0) {
    setStudents(allStudents);
    return;
  }

  const filteredIds = filteredData.map((s) => s.id);

  const matchedRegisteredStudents = allStudents.filter((s) =>
    filteredIds.includes(s.id)
  );

  setStudents(matchedRegisteredStudents);
};



  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <StudentHeader onFiltered={handleFiltered} />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <StudentTable students={students} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default StudentList;
